fbm.add("util/screens", [], function () {

    class Image {

        constructor(image, src) {
            this.image = image;
            let {width, height} = this.image.parentElement.getBoundingClientRect();
            this.image.setAttribute("width", width);
            this.image.src = src;
            this.image.onload = () => {
                window.addEventListener("resize", () => this.resize());
            };
        }

        remove() {
            this.image.remove();
        }

        resize() {
            setTimeout(() => {
                let {width, height} = this.image.parentElement.getBoundingClientRect();
                width = width * .75;
                this.image.setAttribute("width", width);
            }, 250);
        }
    }

    function addClasses(el, ...cls) {
        let list = [...cls].filter(Boolean);
        el.classList.add(...list);
    }

    function getScreen(...cls) {
        let div = document.createElement("div");
        addClasses(div, "fullscreen", ...cls);
        document.querySelector("#crt").appendChild(div);
        return div;
    }

    function addImage(screenName, imgSrc, cls = "") {
        let screen = getScreen(screenName);
        return addImageToScreen(screen, imgSrc, cls);
    }

    function addImageToScreen(screen, imgSrc, cls = "") {
        let image = el('img', screen, cls);
        return {
            screen,
            image: new Image(image, imgSrc)
        };
    }

    function toggleFullscreen(isFullscreen) {
        document.body.classList.toggle("fullscreen", isFullscreen);
    }

    /** Attempts to load template HTML from the given path and includes them in the <head>. */
    async function loadTemplates(path) {
        let txt = await fetch(path).then((res) => res.text());
        let html = new DOMParser().parseFromString(txt, "text/html");
        let templates = html.querySelectorAll("template");

        templates.forEach((template) => {
            document.head.appendChild(template);
        });
    }

    /** Clones the template and adds it to the container. */
    async function addTemplate(id, container, options = {}) {
        let template = document.querySelector(`template#${id}`);
        if (!template) {
            throw Error("Template not found");
        }
        // Clone is the document fragment of the template
        let clone = document.importNode(template.content, true);

        if (template.dataset.type) {
            await type(clone.textContent, options, container);
        } else {
            container.appendChild(clone);
        }

        // We cannot return clone here
        // https://stackoverflow.com/questions/27945721/how-to-clone-and-modify-from-html5-template-tag
        return container.childNodes;
    }

    /** Creates a new screen and loads the given template into it. */
    async function showTemplateScreen(id) {
        let screen = getScreen(id);
        await addTemplate(id, screen);
        return screen;
    }

    /**
     * Creates an element and adds it to the given container (or terminal screen if undefined).
     * @param {String} type The type of element to create.
     * @param {Element} container The container to add the created element to.
     * @param {String} cls The class to apply to the created element.
     * @param {Object} attrs Extra attributes to set on the element.
     */
    function el(
        type,
        container = document.querySelector(".terminal"),
        cls = "",
        attrs
    ) {
        let el = document.createElement(type);
        addClasses(el, cls);

        container.appendChild(el);

        if (attrs) {
            Object.entries(attrs).forEach(([key, value]) => {
                el.setAttribute(key, value);
            });
        }
        return el;
    }

    /**
     * Creates a <div> and adds it to the screen.
     * @param {Element} container The container to add the created element to.
     * @param {String} cls The class to apply to the created element.
     */
    function div(...args) {
        return el("div", ...args);
    }

    function clear(screen = document.querySelector(".terminal")) {
        screen.innerHTML = "";
    }

    return {
        clear,
        getScreen,
        toggleFullscreen,
        div,
        el,
        loadTemplates,
        addTemplate,
        showTemplateScreen,
        addImage,
        addImageToScreen
    }
});
